package com.shreyasjoshi.components

import androidx.compose.runtime.*
import org.jetbrains.compose.web.dom.*
import com.shreyasjoshi.models.PortfolioData

@Composable
fun Footer(
    isDarkMode: Boolean,
    onOpenResumeModal: () -> Unit
) {
    val info = PortfolioData.personalInfo

    Footer(
        attrs = {
            classNames(
                "portfolio-footer", "py-12", "px-4", "sm:px-6", "lg:px-8", "border-t", "transition-colors",
                if (isDarkMode) "bg-[#050505] border-white/10 text-white/50"
                else "bg-slate-100 border-slate-200 text-slate-600"
            )
        }
    ) {
        Div(attrs = { classNames("max-w-6xl", "mx-auto", "space-y-8") }) {
            Div(attrs = { classNames("flex", "flex-col", "lg:flex-row", "items-center", "justify-between", "gap-6") }) {
                // Logo & Headline
                Div(attrs = { classNames("flex", "items-center", "gap-3") }) {
                    Div(
                        attrs = {
                            classNames(
                                "w-8", "h-8", "rounded-sm", "bg-[#189AD3]", "flex", "items-center", "justify-center",
                                "text-white", "font-mono", "font-bold", "text-xs", "tracking-wider", "shadow-sm"
                            )
                        }
                    ) {
                        Text("SJ")
                    }
                    Div {
                        Div(
                            attrs = {
                                classNames(
                                    "font-bold", "text-sm",
                                    if (isDarkMode) "text-white" else "text-slate-900"
                                )
                            }
                        ) {
                            Text(info.name)
                        }
                        Div(attrs = { classNames("text-xs", "font-mono", "text-[#189AD3]") }) {
                            Text("Senior Android Developer • AAOS & AOSP")
                        }
                    }
                }

                // Quick Navigation Links
                Div(attrs = { classNames("flex", "flex-wrap", "items-center", "justify-center", "gap-6", "text-xs", "font-medium") }) {
                    A(href = "#about", attrs = { classNames(if (isDarkMode) "hover:text-white" else "hover:text-slate-900", "transition-colors") }) { Text("About") }
                    A(href = "#experience", attrs = { classNames(if (isDarkMode) "hover:text-white" else "hover:text-slate-900", "transition-colors") }) { Text("Experience") }
                    A(href = "#projects", attrs = { classNames(if (isDarkMode) "hover:text-white" else "hover:text-slate-900", "transition-colors") }) { Text("Projects") }
                    A(href = "#skills", attrs = { classNames(if (isDarkMode) "hover:text-white" else "hover:text-slate-900", "transition-colors") }) { Text("Skills") }
                    A(href = "#knowledge", attrs = { classNames(if (isDarkMode) "hover:text-white" else "hover:text-slate-900", "transition-colors") }) { Text("Knowledge") }
                    A(href = "#contact", attrs = { classNames(if (isDarkMode) "hover:text-white" else "hover:text-slate-900", "transition-colors") }) { Text("Contact") }

                    Button(
                        attrs = {
                            classNames("text-[#189AD3]", "hover:underline", "font-mono", "text-xs")
                            onClick { onOpenResumeModal() }
                        }
                    ) {
                        Text("Resume PDF")
                    }
                }

                // Back to Top Anchor
                A(
                    href = "#",
                    attrs = {
                        classNames(
                            "px-3", "py-1.5", "rounded-sm", "border", "font-mono", "text-xs", "transition-all",
                            if (isDarkMode) "bg-[#0a0a0a] border-white/10 text-white/70 hover:text-white hover:border-white/30"
                            else "bg-white border-slate-200 text-slate-600 hover:text-slate-900 shadow-sm"
                        )
                    }
                ) {
                    Text("↑ Top")
                }
            }

            // Bottom copyright
            Div(
                attrs = {
                    classNames(
                        "pt-6", "border-t", "flex", "flex-col", "lg:flex-row", "items-center", "justify-between", "gap-3", "text-xs",
                        if (isDarkMode) "border-white/10 text-white/40" else "border-slate-200 text-slate-500"
                    )
                }
            ) {
                Div {
                    Text("© 2026 ${info.name}. Built with Kotlin Multiplatform, Compose HTML & Kobweb.")
                }
                Div(attrs = { classNames("flex", "items-center", "gap-4", "font-mono") }) {
                    A(href = info.linkedin, attrs = { classNames("hover:underline") }) { Text("LinkedIn") }
                    A(href = info.knowledgeBase, attrs = { classNames("hover:underline") }) { Text("Knowledge Base") }
                    A(href = "/Shreyas_Joshi_Resume.pdf", attrs = { classNames("hover:underline") }) { Text("Resume PDF") }
                }
            }
        }
    }
}


